import { createContext } from "react";

export const TooltipDatesContext = createContext<Map<string, string> | null>(
  null,
);
